import i18n from '@/plugins/i18n';
import * as types from '@/components/Database/database.types';
import { BYTES_TO_MB_CONVERSION_VALUE } from '@/utils/templates/databaseTemplate/database.constants';
const hardwareMYGraphs = () => ({
  lineCharts: [
    {
      width: '48%',
      header: {
        title: i18n.global.t('dbm.cpuUsage'),
        content: [],
        HideCenterMiscContent: true,
      },
      chartColor: ['#abc0ff'],
      height: '12.5em',
      entityType: 'ServiceInstance',
      independentSelector: false,
      metricType: 'REGULAR_VALUE',
      metricName: 'meter_cpu_usage',
      queryMetricType: 'readMetricsValues',
      childQueries: [],
      chartType: 'ApexChartLine',
      axisLabels: {
        x: i18n.global.t('dbm.time'),
        y: i18n.global.t('dbm.percentage'),
      },
      show: true,
      showForSingleSeries: true,
    },
    {
      width: '48%',
      header: {
        title: i18n.global.t('dbm.memoryUsage'),
        content: [],
        HideCenterMiscContent: true,
      },
      chartColor: ['#abc0ff'],
      height: '12.5em',
      entityType: 'ServiceInstance',
      independentSelector: false,
      metricType: 'REGULAR_VALUE',
      metricName: 'meter_memory_usage',
      queryMetricType: 'readMetricsValues',
      childQueries: [],
      chartType: 'ApexChartLine',
      axisLabels: {
        x: i18n.global.t('dbm.time'),
        y: i18n.global.t('dbm.mb'),
      },
      showLegendForSeries: true,
      aggregation: '/',
      aggregationNum: BYTES_TO_MB_CONVERSION_VALUE,
    },
    {
      width: '48%',
      header: {
        title: i18n.global.t('dbm.networkI/O'),
        content: [],
        HideCenterMiscContent: true,
      },
      chartColor: ['#abc0ff', '#1fb4ff'],
      height: '12.5em',
      entityType: 'ServiceInstance',
      independentSelector: false,
      metricType: 'REGULAR_VALUE',
      metricName: 'meter_io_network_bytes_received,meter_io_network_bytes_sent',
      queryMetricType: 'readMetricsValues',
      childQueries: [],
      chartType: 'ApexChartLine',
      axisLabels: {
        x: i18n.global.t('dbm.time'),
        y: i18n.global.t('dbm.mb'),
      },
      showLegendForSeries: true,
      aggregation: '/',
      aggregationNum: BYTES_TO_MB_CONVERSION_VALUE,
    },
    {
      width: '48%',
      header: {
        title: i18n.global.t('dbm.totalReadWrite'),
        content: [],
        HideCenterMiscContent: true,
      },
      chartColor: ['#856b92', '#f2dafe'],
      height: '12.5em',
      entityType: 'ServiceInstance',
      independentSelector: false,
      metricType: 'REGULAR_VALUE',
      metricName: 'meter_io_total_reads,meter_io_total_writes',
      queryMetricType: 'readMetricsValues',
      childQueries: [],
      chartType: 'ApexChartLine',
      axisLabels: {
        x: i18n.global.t('dbm.time'),
        y: i18n.global.t('dbm.count'),
      },
      showLegendForSeries: true,
    },
    {
      width: '48%',
      header: {
        title: i18n.global.t('dbm.totalBytesWritten&Read'),
        content: [],
        HideCenterMiscContent: true,
      },
      chartColor: ['#a3ff99', '#b4ccb7'],
      height: '12.5em',
      entityType: 'ServiceInstance',
      independentSelector: false,
      metricType: 'REGULAR_VALUE',
      metricName: 'meter_io_total_bytes_written,meter_io_total_bytes_read',
      queryMetricType: 'readMetricsValues',
      childQueries: [],
      chartType: 'ApexChartLine',
      axisLabels: {
        x: i18n.global.t('dbm.time'),
        y: i18n.global.t('dbm.mb'),
      },
      aggregation: '/',
      aggregationNum: BYTES_TO_MB_CONVERSION_VALUE,
      showLegendForSeries: true,
    },
  ],
  cardComponents: {
    width: '46.3%',
    cardName: [
      i18n.global.t('dbm.card.osType'),
      i18n.global.t('dbm.card.architecture'),
      i18n.global.t('dbm.card.hostName'),
      i18n.global.t('dbm.card.availability'),
    ],
    clusterCardsName: [
      i18n.global.t('dbm.card.loadAverage'),
      i18n.global.t('dbm.card.host'),
      i18n.global.t('dbm.card.port'),
      i18n.global.t('dbm.card.role'),
      i18n.global.t('dbm.card.status'),
    ],
    cardNamesMap: {
      [types.cardNames.TYPE_OF_OS]: types.cardValues.OS_TYPE,
      [types.cardNames.ARCHITECTURE]: types.cardValues.OS_ARCH,
      [types.cardNames.Host_Name]: types.cardValues.OS_NAME,
      [types.cardNames.Availability]: types.cardValues.AVAILABILITY,
    },
    clusterCardNamesMap: {
      [types.mysqlClusterCardNames.LOAD_AVG]:
        types.mysqlClusterCardValues.LOAD_AVG,
      [types.mysqlClusterCardNames.PORT]: types.mysqlClusterCardValues.PORT,
      [types.mysqlClusterCardNames.HOST]: types.mysqlClusterCardValues.HOST,
      [types.mysqlClusterCardNames.ROLE]: types.mysqlClusterCardValues.ROLE,
      [types.mysqlClusterCardNames.STATUS]: types.mysqlClusterCardValues.STATUS,
    },
  },
  StorageCardComponents: {
    storageCards: [
      {
        label: i18n.global.t('dbm.card.cpuStorage'),
        width: '46.3%',
      },
      {
        label: i18n.global.t('dbm.card.memoryStorageinMB'),
        width: '46.3%',
      },
    ],
  },
});

export default hardwareMYGraphs;
